<script>
export default {
    name: "SimilarPatientsAction",

    props: {
        showModal: Boolean,
        similarPatients: Array,
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-3/4 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-base">Similar Patients</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3 overflow-auto">
            <table class="table">
                <thead class="bg-blue-500 text-sm text-white">
                    <tr class="flex w-full">
                        <th class="p-tiny w-1/3">Patient</th>
                        <th class="p-tiny flex-1">National ID</th>
                        <th class="p-tiny flex-1">Cellphone</th>
                        <th class="p-tiny flex-1">IP File No</th>
                        <th class="p-tiny flex-1">OP File No</th>
                        <th class="p-tiny flex-1">Visits</th>
                        <th class="p-tiny flex-1">Visit</th>
                    </tr>
                </thead>
                <tbody class="text-xs font-semibold bg-gray-200 flex flex-col items-center 
                    overflow-auto w-full" style="max-height: 60vh;">
                    <tr v-for="(pat,idx) in similarPatients" :key="idx" class="flex w-full">
                        <td class="p-tiny w-1/3">
                            <h5 class="text-sm leading-5 font-medium text-gray-900">{{ pat.names }}</h5>
                            <h5 class="text-xs leading-5 text-gray-700">MRN: {{ pat.patienT_ID }}</h5>
                            <h5 class="text-xs leading-5 text-gray-700">DOB: {{ pat.dob | dateFormat }}</h5>
                            <h5 class="text-xs leading-5 text-gray-700">Gender:{{ pat.gender }} </h5>
                        </td>
                        <td class="p-tiny flex-1">{{ pat.nationalid }}</td>
                        <td class="p-tiny flex-1">{{ pat.celL_PHONE }}</td>
                        <td class="p-tiny flex-1">{{ pat.ipfileno }}</td>
                        <td class="p-tiny flex-1">{{ pat.opfileno }}</td>
                        <td class="p-tiny flex-1">{{ pat.visitCount }}</td>
                        <td class="p-tiny flex-1">
                            <router-link  
                                class="btn-sm text-xs btn-info rounded" 
                                :to="{ name: `registration.visit-patient.create`, 
                                    params: {
                                        patientID: pat.patienT_ID 
                                    }}"><i class="fa fa-pen"></i> Visit</router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-6" 
            @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button 
            @click.prevent="$emit(`saveSimilar`)"
            class="btn-primary btn-sm text-xs rounded">
                <i class="fa fa-redo"></i> Proceed With Registration</button>
      </template>
    </tail-modal>
</template>